import React from 'react';
import { BookOpen, Coffee, Utensils, Moon, Gift, CheckSquare, LineChart } from 'lucide-react';
export function OfferStack() {
  return <section id="offer-stack" className="bg-blanco pb-16 md:pb-24 px-4" data-id="element-113">
      <div className="max-w-5xl mx-auto" data-id="element-114">
        <div className="text-center mb-12" data-id="element-115">
          <h2 className="text-[28px] md:text-[40px] font-playfair font-bold text-marron" data-id="element-116">
            📘 LO QUE RECIBES HOY
          </h2>
          <div className="w-24 h-1 bg-terracota mx-auto mt-6 rounded-full" data-id="element-117"></div>
        </div>

        <div className="space-y-8" data-id="element-118">
          {/* Item 1 */}
          <div className="bg-white rounded-xl shadow-card p-6 md:p-8 border-l-4 border-verde flex flex-col md:flex-row gap-6 items-start relative overflow-hidden" data-id="element-119">
            <div className="absolute top-4 right-4 bg-terracota/10 text-terracota text-sm font-bold px-3 py-1 rounded-full" data-id="element-120">
              Valor: $47
            </div>
            <div className="bg-crema p-4 rounded-full flex-shrink-0" data-id="element-121">
              <BookOpen className="w-8 h-8 text-marron" data-id="element-122" />
            </div>
            <div data-id="element-123">
              <h3 className="text-xl md:text-2xl font-montserrat font-bold text-marron mb-3" data-id="element-124">
                ① MANUAL MAESTRO BIO-SÍNTESIS 3™
              </h3>
              <p className="text-carbon mb-4" data-id="element-125">
                El protocolo científico completo traducido a lenguaje accesible:
              </p>
              <ul className="space-y-2 text-carbon/80" data-id="element-126">
                <li className="flex items-start" data-id="element-127">
                  <span className="text-verde mr-2" data-id="element-128">✅</span> Por qué el
                  colágeno en polvo es biológicamente ineficiente.
                </li>
                <li className="flex items-start" data-id="element-129">
                  <span className="text-verde mr-2" data-id="element-130">✅</span> El Triángulo de la
                  Juventud: Los 3 aminoácidos exactos y cómo combinarlos.
                </li>
                <li className="flex items-start" data-id="element-131">
                  <span className="text-verde mr-2" data-id="element-132">✅</span> El Asesino
                  Silencioso: Cómo bloquear la Glicación con alimentos
                  específicos.
                </li>
                <li className="flex items-start" data-id="element-133">
                  <span className="text-verde mr-2" data-id="element-134">✅</span> El Oro Líquido: La
                  receta maestra del Caldo de Huesos Medicinal.
                </li>
                <li className="flex items-start" data-id="element-135">
                  <span className="text-verde mr-2" data-id="element-136">✅</span> Protocolo de
                  Hidratación Celular para reducir líneas de expresión visibles.
                </li>
              </ul>
            </div>
          </div>

          {/* Item 2 */}
          <div className="bg-white rounded-xl shadow-card p-6 md:p-8 border-l-4 border-verde flex flex-col md:flex-row gap-6 items-start relative overflow-hidden" data-id="element-137">
            <div className="absolute top-4 right-4 bg-terracota/10 text-terracota text-sm font-bold px-3 py-1 rounded-full" data-id="element-138">
              Valor: $17
            </div>
            <div className="bg-crema p-4 rounded-full flex-shrink-0" data-id="element-139">
              <Coffee className="w-8 h-8 text-marron" data-id="element-140" />
            </div>
            <div className="w-full" data-id="element-141">
              <h3 className="text-xl md:text-2xl font-montserrat font-bold text-marron mb-2" data-id="element-142">
                ② LOS 5 DESAYUNOS BIO-ESTIMULADORES
              </h3>
              <p className="text-carbon italic mb-4" data-id="element-143">
                Activa la síntesis de colágeno desde la primera comida del día
              </p>
              <div className="overflow-x-auto" data-id="element-144">
                <table className="w-full text-sm text-left" data-id="element-145">
                  <tbody className="divide-y divide-gray-100" data-id="element-146">
                    <tr className="py-2" data-id="element-147">
                      <td className="py-2 font-medium text-marron" data-id="element-148">
                        1. Tortilla de Claras con Espinacas y Pimiento Rojo
                      </td>
                      <td className="py-2 text-verde font-medium" data-id="element-149">
                        Prolina + Vitamina C simultánea
                      </td>
                    </tr>
                    <tr className="py-2" data-id="element-150">
                      <td className="py-2 font-medium text-marron" data-id="element-151">
                        2. Bowl de Quinoa con Frutos Rojos y Semillas de Cáñamo
                      </td>
                      <td className="py-2 text-verde font-medium" data-id="element-152">
                        Lisina completa + Anti-glicación
                      </td>
                    </tr>
                    <tr className="py-2" data-id="element-153">
                      <td className="py-2 font-medium text-marron" data-id="element-154">
                        3. Tostada de Grano Entero con Aguacate y Huevo Pochado
                      </td>
                      <td className="py-2 text-verde font-medium" data-id="element-155">
                        Grasas dérmicas + Colina
                      </td>
                    </tr>
                    <tr className="py-2" data-id="element-156">
                      <td className="py-2 font-medium text-marron" data-id="element-157">
                        4. Smoothie de Mango, Jengibre y Proteína de Cáñamo
                      </td>
                      <td className="py-2 text-verde font-medium" data-id="element-158">
                        Enzimas digestivas + Glicina
                      </td>
                    </tr>
                    <tr className="py-2" data-id="element-159">
                      <td className="py-2 font-medium text-marron" data-id="element-160">
                        5. Pudding de Chía con Leche de Coco y Kiwi
                      </td>
                      <td className="py-2 text-verde font-medium" data-id="element-161">
                        Omega-3 + Vitamina C pura
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          {/* Item 3 */}
          <div className="bg-white rounded-xl shadow-card p-6 md:p-8 border-l-4 border-verde flex flex-col md:flex-row gap-6 items-start relative overflow-hidden" data-id="element-162">
            <div className="absolute top-4 right-4 bg-terracota/10 text-terracota text-sm font-bold px-3 py-1 rounded-full" data-id="element-163">
              Valor: $17
            </div>
            <div className="bg-crema p-4 rounded-full flex-shrink-0" data-id="element-164">
              <Utensils className="w-8 h-8 text-marron" data-id="element-165" />
            </div>
            <div className="w-full" data-id="element-166">
              <h3 className="text-xl md:text-2xl font-montserrat font-bold text-marron mb-2" data-id="element-167">
                ③ LOS 5 ALMUERZOS ANTI-GLICACIÓN
              </h3>
              <p className="text-carbon italic mb-4" data-id="element-168">
                Construye firmeza dérmica durante las horas de mayor actividad
                metabólica
              </p>
              <div className="overflow-x-auto" data-id="element-169">
                <table className="w-full text-sm text-left" data-id="element-170">
                  <tbody className="divide-y divide-gray-100" data-id="element-171">
                    <tr className="py-2" data-id="element-172">
                      <td className="py-2 font-medium text-marron" data-id="element-173">
                        1. Salmón con Piel al Limón sobre Rúcula
                      </td>
                      <td className="py-2 text-verde font-medium" data-id="element-174">
                        Colágeno marino + Omega-3
                      </td>
                    </tr>
                    <tr className="py-2" data-id="element-175">
                      <td className="py-2 font-medium text-marron" data-id="element-176">
                        2. Pollo al Horno con Piel y Brócoli al Vapor
                      </td>
                      <td className="py-2 text-verde font-medium" data-id="element-177">
                        Glicina + Sulforafano anti-AGEs
                      </td>
                    </tr>
                    <tr className="py-2" data-id="element-178">
                      <td className="py-2 font-medium text-marron" data-id="element-179">
                        3. Ensalada de Lentejas Rojas con Tahini
                      </td>
                      <td className="py-2 text-verde font-medium" data-id="element-180">
                        Lisina vegetal + Zinc
                      </td>
                    </tr>
                    <tr className="py-2" data-id="element-181">
                      <td className="py-2 font-medium text-marron" data-id="element-182">
                        4. Bowl de Atún con Aguacate y Tomate Cherry
                      </td>
                      <td className="py-2 text-verde font-medium" data-id="element-183">
                        Selenio + Licopeno
                      </td>
                    </tr>
                    <tr className="py-2" data-id="element-184">
                      <td className="py-2 font-medium text-marron" data-id="element-185">
                        5. Wrap de Pavo en Hoja de Lechuga con Hummus
                      </td>
                      <td className="py-2 text-verde font-medium" data-id="element-186">
                        Proteína magra + Beta-caroteno
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          {/* Item 4 */}
          <div className="bg-white rounded-xl shadow-card p-6 md:p-8 border-l-4 border-verde flex flex-col md:flex-row gap-6 items-start relative overflow-hidden" data-id="element-187">
            <div className="absolute top-4 right-4 bg-terracota/10 text-terracota text-sm font-bold px-3 py-1 rounded-full" data-id="element-188">
              Valor: $17
            </div>
            <div className="bg-crema p-4 rounded-full flex-shrink-0" data-id="element-189">
              <Moon className="w-8 h-8 text-marron" data-id="element-190" />
            </div>
            <div className="w-full" data-id="element-191">
              <h3 className="text-xl md:text-2xl font-montserrat font-bold text-marron mb-2" data-id="element-192">
                ④ LAS 5 CENAS REPARADORAS DE DERMIS
              </h3>
              <p className="text-carbon italic mb-4" data-id="element-193">
                La piel se regenera mientras duermes — estas cenas maximizan ese
                proceso
              </p>
              <div className="overflow-x-auto" data-id="element-194">
                <table className="w-full text-sm text-left" data-id="element-195">
                  <tbody className="divide-y divide-gray-100" data-id="element-196">
                    <tr className="py-2" data-id="element-197">
                      <td className="py-2 font-medium text-marron" data-id="element-198">
                        1. Caldo de Huesos con Jengibre y Cúrcuma
                      </td>
                      <td className="py-2 text-verde font-medium" data-id="element-199">
                        Glicina pura + Anti-inflamatorio
                      </td>
                    </tr>
                    <tr className="py-2" data-id="element-200">
                      <td className="py-2 font-medium text-marron" data-id="element-201">
                        2. Crema de Calabaza con Aceite de Coco
                      </td>
                      <td className="py-2 text-verde font-medium" data-id="element-202">
                        Beta-caroteno + Zinc + Triptófano
                      </td>
                    </tr>
                    <tr className="py-2" data-id="element-203">
                      <td className="py-2 font-medium text-marron" data-id="element-204">
                        3. Trucha al Vapor con Espárragos y Limón
                      </td>
                      <td className="py-2 text-verde font-medium" data-id="element-205">
                        Colágeno marino + Prolina
                      </td>
                    </tr>
                    <tr className="py-2" data-id="element-206">
                      <td className="py-2 font-medium text-marron" data-id="element-207">
                        4. Revuelto de Huevos con Champiñones y Tomillo
                      </td>
                      <td className="py-2 text-verde font-medium" data-id="element-208">
                        Prolina + Ergotioneína antioxidante
                      </td>
                    </tr>
                    <tr className="py-2" data-id="element-209">
                      <td className="py-2 font-medium text-marron" data-id="element-210">
                        5. Sopa de Pollo con Verduras de Raíz
                      </td>
                      <td className="py-2 text-verde font-medium" data-id="element-211">
                        Triple aminoácido + Minerales
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          {/* Item 5 - BONUS */}
          <div className="bg-gradient-to-br from-terracota/10 to-white rounded-xl shadow-card p-6 md:p-8 border-l-4 border-terracota flex flex-col md:flex-row gap-6 items-start relative overflow-hidden" data-id="element-212">
            <div className="absolute top-4 right-4 bg-terracota text-white text-sm font-bold px-3 py-1 rounded-full" data-id="element-213">
              Valor: $27
            </div>
            <div className="bg-terracota/20 p-4 rounded-full flex-shrink-0" data-id="element-214">
              <Gift className="w-8 h-8 text-terracota" data-id="element-215" />
            </div>
            <div className="w-full" data-id="element-216">
              <h3 className="text-xl md:text-2xl font-montserrat font-bold text-terracota mb-2" data-id="element-217">
                ⑤ 🎁 BONO: LAS 6 COLACIONES REJUVENECEDORAS
              </h3>
              <p className="text-carbon italic mb-4" data-id="element-218">
                Frena el antojo, bloquea la glicación y construye colágeno entre
                comidas
              </p>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm" data-id="element-219">
                <div className="bg-white p-3 rounded shadow-sm" data-id="element-220">
                  <span className="font-bold text-marron" data-id="element-221">
                    1. Kiwi + Almendras:
                  </span>{' '}
                  Vit C + Vit E + Cobre
                </div>
                <div className="bg-white p-3 rounded shadow-sm" data-id="element-222">
                  <span className="font-bold text-marron" data-id="element-223">
                    2. Gelatina Natural:
                  </span>{' '}
                  Glicina directa + Cero azúcar
                </div>
                <div className="bg-white p-3 rounded shadow-sm" data-id="element-224">
                  <span className="font-bold text-marron" data-id="element-225">
                    3. Yogur Griego + Cúrcuma:
                  </span>{' '}
                  Prolina + Curcumina
                </div>
                <div className="bg-white p-3 rounded shadow-sm" data-id="element-226">
                  <span className="font-bold text-marron" data-id="element-227">
                    4. Pepino + Hummus:
                  </span>{' '}
                  Sílice dérmico + Lisina
                </div>
                <div className="bg-white p-3 rounded shadow-sm" data-id="element-228">
                  <span className="font-bold text-marron" data-id="element-229">5. Té Matcha:</span>{' '}
                  EGCG anti-glicación
                </div>
                <div className="bg-white p-3 rounded shadow-sm" data-id="element-230">
                  <span className="font-bold text-marron" data-id="element-231">
                    6. Moras Azules + Ricotta:
                  </span>{' '}
                  Antocianinas + Proteína
                </div>
              </div>
            </div>
          </div>

          {/* Items 6 & 7 */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-232">
            <div className="bg-white rounded-xl shadow-card p-6 border-l-4 border-verde relative" data-id="element-233">
              <div className="absolute top-4 right-4 bg-terracota/10 text-terracota text-sm font-bold px-3 py-1 rounded-full" data-id="element-234">
                Valor: $9
              </div>
              <CheckSquare className="w-8 h-8 text-marron mb-4" data-id="element-235" />
              <h3 className="text-lg font-montserrat font-bold text-marron mb-2" data-id="element-236">
                ⑥ CHECKLIST DE SUPERALIMENTOS
              </h3>
              <p className="text-carbon text-sm" data-id="element-237">
                Los 15 ingredientes esenciales. Lista imprimible para llevar al
                supermercado hoy mismo.
              </p>
            </div>
            <div className="bg-white rounded-xl shadow-card p-6 border-l-4 border-verde relative" data-id="element-238">
              <div className="absolute top-4 right-4 bg-terracota/10 text-terracota text-sm font-bold px-3 py-1 rounded-full" data-id="element-239">
                Valor: $9
              </div>
              <LineChart className="w-8 h-8 text-marron mb-4" data-id="element-240" />
              <h3 className="text-lg font-montserrat font-bold text-marron mb-2" data-id="element-241">
                ⑦ RASTREADOR DE RESULTADOS
              </h3>
              <p className="text-carbon text-sm" data-id="element-242">
                Mide cambios reales en luminosidad, firmeza, hidratación y
                líneas de expresión en 90 días.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}